{
  "metadata": {
    "id": "vesper-light",
    "name": "Vesper",
    "description": "Портировано из темы «Vesper» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "vesper.json",
      "project": "raunofreiberg",
      "url": "https://github.com/raunofreiberg/vesper",
      "upstreamFile": "packages/ui/src/theme/themes/vesper.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 23.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.47,
      "paletteMaxS": 0.51,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.7,
      "syntaxVsTextMinDeltaE": 0,
      "chartsMinDeltaE": 29.1,
      "textSeparationDeltaE": 22.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "keyword",
          "deltaE": 4.8
        },
        {
          "a": "number",
          "b": "type",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#e06500",
      "hover": "#ca5b00",
      "active": "#b85300",
      "foreground": "#000000",
      "muted": "#e0650080",
      "emphasis": "#e06500"
    },
    "surface": {
      "background": "#F0F0F0",
      "foreground": "#101010",
      "muted": "#c2c2c2",
      "mutedForeground": "#404040",
      "elevated": "#acacac",
      "elevatedForeground": "#101010",
      "raised": "#919191",
      "raisedForeground": "#101010",
      "overlay": "#f0f0f033",
      "subtle": "#d9d9d9"
    },
    "interactive": {
      "border": "#8b8b8b",
      "borderHover": "#b1b1b1",
      "borderFocus": "#e06500",
      "selection": "#10101024",
      "selectionForeground": "#101010",
      "focus": "#e0650059",
      "focusRing": "#e0650047",
      "cursor": "#101010",
      "hover": "#10101017",
      "active": "#10101024"
    },
    "status": {
      "error": "#dc0000",
      "errorForeground": "#ffffff",
      "errorBackground": "#dc00001a",
      "errorBorder": "#dc000059",
      "warning": "#b35100",
      "warningForeground": "#ffffff",
      "warningBackground": "#b351001a",
      "warningBorder": "#b3510059",
      "success": "#007a5a",
      "successForeground": "#ffffff",
      "successBackground": "#007a5a1a",
      "successBorder": "#007a5a59",
      "info": "#b35100",
      "infoForeground": "#ffffff",
      "infoBackground": "#b351001a",
      "infoBorder": "#b3510059"
    },
    "pr": {
      "open": "#007a5a",
      "draft": "#4f4f4f",
      "blocked": "#b35100",
      "merged": "#B30000",
      "closed": "#dc0000"
    },
    "syntax": {
      "base": {
        "background": "#c2c2c2",
        "foreground": "#101010",
        "comment": "#4f4f4f",
        "keyword": "#4f4f4f",
        "string": "#0c5a4b",
        "number": "#734517",
        "function": "#101010",
        "variable": "#101010",
        "type": "#734517",
        "operator": "#505030"
      },
      "tokens": {
        "commentDoc": "#4f4f4f",
        "stringEscape": "#505030",
        "keywordImport": "#4f4f4f",
        "storageModifier": "#4f4f4f",
        "functionCall": "#101010",
        "method": "#101010",
        "variableProperty": "#101010",
        "variableOther": "#101010",
        "variableGlobal": "#734517",
        "variableLocal": "#505030",
        "parameter": "#101010",
        "constant": "#734517",
        "class": "#734517",
        "className": "#734517",
        "interface": "#734517",
        "struct": "#734517",
        "enum": "#734517",
        "typeParameter": "#734517",
        "namespace": "#734517",
        "module": "#4f4f4f",
        "tag": "#4f4f4f",
        "jsxTag": "#4f4f4f",
        "tagAttribute": "#101010",
        "tagAttributeValue": "#0c5a4b",
        "boolean": "#734517",
        "decorator": "#4f4f4f",
        "label": "#101010",
        "regexp": "#0c5a4b"
      }
    },
    "charts": {
      "series": [
        "#e06500",
        "#b38d00",
        "#007a5a",
        "#756115",
        "#dc0000"
      ]
    },
    "chat": {
      "background": "#F0F0F0",
      "userMessage": "#101010",
      "userMessageBackground": "#acacac",
      "assistantMessage": "#101010",
      "assistantMessageBackground": "#c2c2c2",
      "timestamp": "#4f4f4f",
      "divider": "#8b8b8b",
      "typing": "#4f4f4f"
    },
    "loading": {
      "spinner": "#e06500",
      "spinnerTrack": "#c2c2c2",
      "skeleton": "#c2c2c2",
      "shimmer": "#b7b7b7"
    },
    "tools": {
      "background": "#c2c2c2",
      "border": "#8b8b8b",
      "headerHover": "#b9b9b9",
      "icon": "#ad4e00",
      "title": "#101010",
      "description": "#4f4f4f",
      "edit": {
        "added": "#007a5a",
        "addedBackground": "#007a5a1a",
        "removed": "#dc0000",
        "removedBackground": "#dc00001a",
        "modified": "#b35100",
        "modifiedBackground": "#b351001a",
        "lineNumber": "#4f4f4f"
      }
    },
    "markdown": {
      "heading1": "#101010",
      "heading2": "#101010",
      "heading3": "#101010",
      "heading4": "#101010",
      "link": "#b25000",
      "linkHover": "#b05000",
      "inlineCode": "#0c5a4b",
      "inlineCodeBackground": "#c2c2c2",
      "blockquote": "#4f4f4f",
      "blockquoteBorder": "#8b8b8b",
      "listMarker": "#db6300",
      "bold": "#101010",
      "italic": "#101010e6",
      "strikethrough": "#4f4f4f",
      "hr": "#8b8b8b"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c3624d",
        "foreground": "#000000",
        "contrast": 5.17
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d3a793",
        "foreground": "#000000",
        "contrast": 9.72
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c79555",
        "foreground": "#000000",
        "contrast": 7.86
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d7d799",
        "foreground": "#000000",
        "contrast": 14.07
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#96c060",
        "foreground": "#000000",
        "contrast": 10.01
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#5bc959",
        "foreground": "#000000",
        "contrast": 9.94
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#60be84",
        "foreground": "#000000",
        "contrast": 9.2
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#93dcc9",
        "foreground": "#000000",
        "contrast": 13.32
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#58b0c7",
        "foreground": "#000000",
        "contrast": 8.45
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4e84c2",
        "foreground": "#000000",
        "contrast": 5.4
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4865bf",
        "foreground": "#ffffff",
        "contrast": 5.4
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#664bbe",
        "foreground": "#ffffff",
        "contrast": 6.33
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#ae8ad5",
        "foreground": "#000000",
        "contrast": 7.4
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c453c1",
        "foreground": "#000000",
        "contrast": 5.35
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c3508f",
        "foreground": "#000000",
        "contrast": 4.86
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d191ae",
        "foreground": "#000000",
        "contrast": 8.37
      }
    ]
  }
}
